// extracted by mini-css-extract-plugin
module.exports = {"bg":"overlay_bg__2gckb","on":"overlay_on__1uSNn","overlay":"overlay_overlay__2cA4c","wide":"overlay_wide__33iey","close":"overlay_close__3JwPy","actions":"overlay_actions__D_vvO"};